import {
  Component,
  EventEmitter,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  Output
} from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import _ from 'lodash';
import { EngagementType } from '../../../models/engagement-type.model';
import { AppConstants } from '../../common/app-constants';
import { OsmosisService } from '../../services/osmosis.service';
import { CommonSharedModule } from '../../common/shared.module';

@Component({
  selector: 'app-document-upload',
  templateUrl: './document-upload.component.html',
  styleUrls: ['./document-upload.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class DocumentUploadComponent implements OnInit {
  notificationMessage: any[] = [];
  privateEngagementTypeList!: EngagementType[];
  uploadDocumentForm!: FormGroup;
  selectedWorkshopType!: number;
  hasError = false;
  hasWarning = false;
  validationSucces = false;
  loading = false;
  selectedEngagementType = '';

  @ViewChild('AccessListFileUpload', { static: false })
  accessListFileUpload!: ElementRef;
  @Input() workshopType!: DocumentUploadComponent;
  @Output() uploadCompletedEvent = new EventEmitter<any>();
  duplicateMpnIDstoShow!: string;
  vOrgIDstoShow!: string;
  paidFacilitatorIDstoShow!: string;
  invalidMpnIDstoShow!: string;
  invalidTPIDstoShow!: string;
  duplicateTPIDstoShow!: string;
  duplicateTenantIDstoShow!: string;
  invalidTenantIDstoShow!: string;
  userType!: string;
  isHybridWithCustomerList!: boolean;
  isHybridWithPartnerList!: boolean;
  isDialogOpen!: boolean;
  fileToUpload!: File | null;

  constructor(
    private osmService: OsmosisService,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.onFromGroup();
  }

  onFromGroup(): void {
    this.uploadDocumentForm = this.formBuilder.group({
      userType: ['']
    });
  }

  showDialog(): void {
    this.isDialogOpen = true;
  }

  closeDialog(): void {
    this.isDialogOpen = false;
    this.hasError = false;
    this.hasWarning = false;
    this.validationSucces = false;

    this.uploadDocumentForm = this.formBuilder.group({
      userType: ['']
    });

    this.duplicateMpnIDstoShow = '';
    this.vOrgIDstoShow = '';
    this.invalidMpnIDstoShow = '';
    this.invalidTPIDstoShow = '';
    this.duplicateTPIDstoShow = '';
    this.duplicateTenantIDstoShow = '';
    this.invalidTenantIDstoShow = '';
    this.userType = '';
    this.fileToUpload = null;
    this.paidFacilitatorIDstoShow = '';
  }

  openFilePicker(fileInput: HTMLInputElement): void {
    this.accessListFileUpload.nativeElement.value = null;
    fileInput.click();
  }

  validateAccessListExcelFile(event): void {
    const isWorkshopTypeValid = _.isNumber(this.selectedWorkshopType);
    const hasFile =
      event.target &&
      !_.isEmpty(event.target.files) &&
      this.validateFileType(event.target.files[0].name);
    const canUpload = isWorkshopTypeValid && hasFile;
    if (canUpload) {
      this.loading = true;
      this.fileToUpload = event.target.files[0];
      const formData = new FormData();

      if (this.fileToUpload) {
        formData.append('file', this.fileToUpload, this.fileToUpload.name);
      }

      this.userType = this.uploadDocumentForm.controls['userType'].value;

      if (this.uploadDocumentForm.controls['userType'].value === 'Partner') {
        this.osmService
          .validatePrivateWorkshopPartnerList(
            this.selectedWorkshopType,
            formData
          )
          .subscribe(
            response => {
              this.loading = false;
              this.hasError = response.hasError;
              this.hasWarning = response.hasWarning;

              let message = AppConstants.validationSuccessMsg;
              if (this.hasWarning) {
                message = AppConstants.uploadWarningMsg;
                this.showNotificationMessage(message, 'warn');
              } else if (this.hasError) {
                message = AppConstants.uploadErrorMsg;
                this.showNotificationMessage(message, 'error');
              } else {
                this.validationSucces = true;
                this.showNotificationMessage(message);
              }

              this.duplicateMpnIDstoShow = this.generateStringOfIds(
                response.duplicateMpnIdList
              );
              this.vOrgIDstoShow = this.generateStringOfIds(
                response.vOrgIdList
              );
              this.invalidMpnIDstoShow = this.generateStringOfIds(
                response.invalidMpnIdList
              );
              this.paidFacilitatorIDstoShow = this.generateStringOfIds(
                response.paidFacilitatorMpnIdList
              );
            },
            () => {
              this.loading = false;
            }
          );
      } else {
        this.osmService
          .validatePrivateWorkshopCustomerList(
            this.selectedWorkshopType,
            formData
          )
          .subscribe(
            response => {
              this.loading = false;
              this.showNotificationMessage(JSON.stringify(response, null, 4));
              this.hasError = response.hasError;
              this.hasWarning = response.hasWarning;
              let message = AppConstants.uploadSuccessMsg;
              if (this.hasWarning) {
                message = AppConstants.uploadWarningMsg;
                this.showNotificationMessage(message, 'warn');
              } else if (this.hasError) {
                message = AppConstants.uploadErrorMsg;
                this.showNotificationMessage(message, 'error');
              } else {
                this.validationSucces = true;
                this.showNotificationMessage(message);
              }

              this.duplicateTPIDstoShow = this.generateStringOfIds(
                response.tpIdListImport.duplicateTPIdList
              );

              this.duplicateTenantIDstoShow = this.generateStringOfIds(
                response.tenantIdListImport.duplicateTenantIdList
              );

              this.invalidTPIDstoShow = this.generateStringOfIds(
                response.tpIdListImport.invalidTPIdList
              );

              this.invalidTenantIDstoShow = this.generateStringOfIds(
                response.tenantIdListImport.invalidTenantIdList
              );
            },
            () => {
              this.loading = false;
            }
          );
      }
    }
  }

  uploadAccessListExcelFile(): void {
    const formData = new FormData();

    if (this.fileToUpload) {
      formData.append('file', this.fileToUpload, this.fileToUpload.name);
    }

    this.userType = this.uploadDocumentForm.controls['userType'].value;
    this.loading = true;

    if (this.userType === 'Partner') {
      this.osmService
        .uploadPrivateWorkshopPartnerList(this.selectedWorkshopType, formData)
        .subscribe(
          () => {
            this.loading = false;
            this.uploadCompletedEvent.emit(true);
            this.closeDialog();
          },
          error => {
            this.loading = false;
            this.showNotificationMessage(JSON.stringify(error, null, 4));
          }
        );
    } else {
      this.osmService
        .uploadPrivateWorkshopCustomerList(this.selectedWorkshopType, formData)
        .subscribe(
          () => {
            this.loading = false;
            this.uploadCompletedEvent.emit(true);
            this.closeDialog();
          },
          error => {
            this.loading = false;
            this.showNotificationMessage(JSON.stringify(error, null, 4));
          }
        );
    }
  }

  validateFileType(fileName: string): boolean {
    const ext = fileName.substring(fileName.lastIndexOf('.') + 1);
    const supportedExtensions = ['xlsm', 'xlsx', 'xls'];
    const index = supportedExtensions.indexOf(ext);

    return index > -1;
  }

  showNotificationMessage(message: string, severity = 'success'): void {
    this.notificationMessage = [];
    this.notificationMessage.push({
      severity: severity,
      detail: message,
      closable: false,
      sticky: true
    } as any);
  }

  generateStringOfIds(idList: string[]): string {
    let idStringToDisplay = '';
    if (idList != null && idList.length > 0) {
      const distinctIdList = _.union(idList);
      distinctIdList.forEach(item => {
        idStringToDisplay =
          idStringToDisplay == null
            ? ' ' + item + ','
            : idStringToDisplay + ' ' + item + ',';
      });
      idStringToDisplay = idStringToDisplay.slice(0, -1);
    }

    return idStringToDisplay;
  }

  isDocumentTypeSelected(): boolean {
    if (this.uploadDocumentForm.controls['userType'].value !== '') {
      return true;
    }

    return false;
  }
}
